/**
* DevExpress Analytics (serializer\eventManager.js)
* Version:  22.2.6
* Build date: Apr 17, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { Disposable } from './utils';
export class EventManager extends Disposable {
    constructor() {
        super(...arguments);
        this._handlers = [];
    }
    dispose() {
        this._handlers = [];
    }
    call(type, args) {
        this._handlers.filter(x => x.type === type).forEach(x => x.value(args));
    }
    addHandler(type, listener) {
        this._handlers.push({
            type: type,
            value: listener
        });
    }
    removeHandler(type, listener) {
        var item = this._handlers.filter(handler => handler.type === type && handler.value === listener)[0];
        var index = this._handlers.indexOf(item);
        if (index !== -1) {
            this._handlers.splice(index, 1);
        }
    }
}
